// Needed for AWS
window.global ||= window;
